import Trix from 'trix/dist/trix'

/* @ngInject */
function PostCoreController ($scope, $cookies, $attrs, $rootScope, $timeout, $sce, $q, $translate, NewAssetService, UdsModalService, PostsService, MessageService, AttachmentService, ModalService, AssetService, GroupService, CONSTANTS, Utils, SliderService, TrixEditorService, CustomerConfigurationsService, AdminService, SegmentService, ToastService, UploadService, BackendErrorParserService, AssetPreviewService, CampaignService, CampaignActionService) {
  const getCreatePostCategoryDialogController = () => $q.when(import('../../../admin/dialogs/create-post-category/create-post-category-dialog.controller'))
  const getNewGroupDialogController = () => $q.when(import('../../../admin/dialogs/new-group/new-group-dialog.controller'))
  const getUpgradeCompanyPlanDialogController = () => import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')
  const getAttachInsideTheModuleModalController = () => import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller')

  const api = {
    getCreatePostCategoryDialogController,
    getNewGroupDialogController,
    _successGetCategories,
    _successAttachThumbnail,
    _handleGetGroupsResponse,
    _handleSuccess,
    _handleSuccessGetUsers,
    _getPostById,
    _getPostsCategories,
    _getGroups,
    _getUsers,
    _getGroupValues,
    _getUserValues,
    _setAttachments,
    _setThumbnail,
    _submitPost,
    _addDropdownValue,
    _createVideoButton,
    _getVideoId,
    _getDefaultReaction,
    _validateCompanyFeatures,
    _openUpgradeCompanyPlanDialog,
    _handleGroupSegmentation,
    _handleSeeReaders,
    _getPreviewAssets,
    _fillInputsWithCampaignInfo,
    _getSelectedCampaign
  }
  const element = $attrs.$$element
  const location = 'posts'

  $scope.currentModule = ''
  $scope.autoShowAfterLogin = false
  $scope.campaigns = []
  $scope.readedLoading = false
  $scope.postVisualized = false
  $scope.dateRange = {
    minDate: moment(),
    maxDate: null
  }

  $scope.lang = $translate.preferredLanguage()

  $scope.reactions = {
    metrics: [
      {
        id: 1,
        label: `⭐ ${Utils.capitalize($translate.instant('stars'))}`,
        value: 'STAR',
        active: true
      },
      {
        id: 2,
        label: `😀 ${Utils.capitalize($translate.instant('emojis'))}`,
        value: 'EMOJI',
        active: false
      }
    ]
  }

  $scope.companyFeatures = {
    advancedFeatures: false,
    groupSegmentation: false
  }
  $scope.allUsersChecked = true
  $scope.trackReactionsChecked = true
  $scope.disabledSelectReactions = false

  $scope.showThumbnail = false

  $scope.flags = {
    bLoading: true,
    bLoadingViewers: false,
    showAdvancedOptions: false,
    bLoadingDownload: false,
    seeReaders: false,
    seeAttachmentLogs: false,
    bLoadingGroups: true,
    bLoadingUsers: true
  }

  const defaultTrackReaction = api._getDefaultReaction($scope.reactions.metrics)

  $scope.form = {
    attachments: [],
    thumbnail: null,
    groups: [],
    targetUsers: [],
    title: '',
    content: '',
    expirationDate: '',
    scheduleDate: '',
    notify: true,
    trackReactionsCached: defaultTrackReaction,
    trackReactions: defaultTrackReaction,
    autoShowAfterLogin: false,
    campaignId: null
  }

  // Thumbnail is treated as an attachment, it is an array because AttachmentService deals with arrays
  $scope.thumbnail = null
  $scope.files = []
  $scope.uploadedFiles = []
  $scope.aGroups = []
  $scope.aUsers = []
  $scope.today = moment()
  $scope.location = 'posts'

  // Used for pagination
  const _iCurrentTop = 100
  let _iCurrentSkipGroups = 0
  let _iGroupsCount = 0

  $scope.currentPostIndex = $scope._currentPostIndex
  $scope.totalPosts = $scope._totalPosts

  this.getApi = () => api

  $scope.isCampaignSelected = false

  $scope.activate = function () {
    $scope.currentModule = 'posts'
    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      api._validateCompanyFeatures(features)

      moment.locale($scope.lang)

      if ($scope._selectedCampaignId) {
        $scope.currentCampaignId = $scope._selectedCampaignId
      }

      if ($scope._editMode) {
        Promise.allSettled([api._getPostsCategories(), api._getGroups(), api._getUsers()])
          .then(() => {
            if ($scope._existingPost) {
              api._getPostById($scope._postId, true)
            } else {
              $scope.isCampaignSelected = !!$scope.currentCampaignId
              api._getSelectedCampaign()
            }
          })
      } else if ($scope._postId) {
        api._getPostById($scope._postId, false)
      }

      $timeout(function () {
        if ($rootScope.isDesktop) {
          api._createVideoButton()
        }
      }, 150, false)

      // weird fix for a very weird bug on chrome that moves every field when opens dropdown, check sometime later if it can be removed
      $timeout(function () {
        jQuery('.new-post-dialog .dropdown, .newPostCategoryDropdownForm').on('click', function () {
          $timeout(function () {
            jQuery('.scrolling.content')[0].scroll(0, jQuery('.scrolling.content')[0].scrollTop + 1)
          }, 0, false)
        })
      }, 100, false)

      TrixEditorService.setupTrixListeners($scope.flags, {
        addToAttachments: (attachment) => {
          $scope.form.attachments.push(attachment)
        },
        removeFromAttachments: (idAttachment) => {
          const attachmentIndex = $scope.form.attachments.findIndex(a => a.id === idAttachment)
          if (attachmentIndex !== -1) {
            $scope.form.attachments = $scope.form.attachments.splice(attachmentIndex, 1)
          }
        }
      })
    })
  }

  function _handleGroupSegmentation (groupSegmentation) {
    let pricingValue = false

    if (!groupSegmentation) {
      pricingValue = true
    }

    $scope.toggleOptions = [
      { label: $translate.instant('users'), value: 'USERS', pricing: false },
      {
        label: $translate.instant('groups'),
        value: 'GROUPS',
        pricing: pricingValue,
        pricingData: {
          name: $translate.instant('billingFeatures.groupsSegmentation'),
          slug: 'POSTS.GROUPS_SEGMENTATION'
        }
      }
    ]
  }

  $scope.onToggleNotifyUser = (event) => {
    const { value } = event.detail

    $scope.form.notify = value
  }

  $scope.onToggleOpenPostUponEntry = (event) => {
    const { value } = event.detail

    $scope.form.autoShowAfterLogin = value
  }

  $scope.navigateToPost = function (index) {
    if ($scope._totalPosts && index >= 0 && index < $scope._totalPosts) {
      $scope.currentPostIndex = index
      $scope.flags.bLoading = true

      if ($scope._storedPosts && $scope._storedPosts[index]) {
        const post = $scope._storedPosts[index]
        $scope._postId = post.id
        $scope.post = post
        $scope.flags.bLoading = false
      } else {
        ModalService.close()
        $scope.flags.bLoading = false
      }
    }
  }

  $scope.previousPost = function () {
    if ($scope.currentPostIndex > 0) {
      const newIndex = $scope.currentPostIndex - 1
      if ($scope._storedPosts && $scope._storedPosts[newIndex]) {
        ModalService.close()
        $timeout(() => {
          ModalService.showModal({
            templateId: 'newPost.html',
            templateUrl: '/posts/dialogs/post/post-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            data: {
              _postId: $scope._storedPosts[newIndex].id,
              _editMode: false,
              _currentPostIndex: newIndex,
              _totalPosts: $scope._totalPosts,
              _storedPosts: $scope._storedPosts,
              previousPost: $scope.previousPost,
              nextPost: $scope.nextPost
            }
          })
        })
      }
    }
  }

  $scope.nextPost = function () {
    if ($scope.currentPostIndex < $scope._totalPosts - 1) {
      const newIndex = $scope.currentPostIndex + 1
      if ($scope._storedPosts && $scope._storedPosts[newIndex]) {
        ModalService.close()
        $timeout(() => {
          ModalService.showModal({
            templateId: 'newPost.html',
            templateUrl: '/posts/dialogs/post/post-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            data: {
              _postId: $scope._storedPosts[newIndex].id,
              _editMode: false,
              _currentPostIndex: newIndex,
              _totalPosts: $scope._totalPosts,
              _storedPosts: $scope._storedPosts,
              previousPost: $scope.previousPost,
              nextPost: $scope.nextPost
            }
          })
        })
      }
    }
  }

  $scope.initializeAutoShowAfterLoginPosts = function (posts) {
    if (!posts || !posts.rows) return

    $scope.autoShowAfterLoginPosts = posts.rows
    $scope._totalPosts = posts.count
    $scope.currentPostIndex = $scope._currentPostIndex || 0

    if ($scope._totalPosts > 0 && !$scope._postId) {
      const firstPost = posts.rows[0]
      if (firstPost) {
        $scope._postId = firstPost.id
        api._getPostById(firstPost.id, false)
      }
    }
  }

  $scope.createPostView = function (post) {
    if ($scope.postVisualized) return

    $scope.readedLoading = true
    PostsService.createPostView(post.id).then(() => {
      SegmentService.track('read-announcement', {
        post_id: post.id,
        automatic_open: post.autoShowAfterLogin
      })

      $scope.readedLoading = false
      $scope.postVisualized = true

      if ($scope._storedPosts && $scope.currentPostIndex >= 0) {
        $scope._storedPosts[$scope.currentPostIndex].visualized = true
      }

      ToastService.defaultSuccessToast()

      const hasUnviewedPosts = $scope._storedPosts?.some((post, index) => {
        return !post.visualized && index !== $scope.currentPostIndex
      })

      if ($scope.currentPostIndex === $scope._totalPosts - 1 && hasUnviewedPosts) {
        const nextUnviewedIndex = $scope._storedPosts?.findIndex(post => !post.visualized)
        if (nextUnviewedIndex >= 0) {
          $scope.navigateToPost(nextUnviewedIndex)
        }
      } else if ($scope.currentPostIndex < $scope._totalPosts - 1) {
        $scope.nextPost()
      } else if (!hasUnviewedPosts) {
        ToastService.showInfoToast($translate.instant('noMoreUnreadPosts'))
      }
    }).catch((error) => {
      console.log({ error })
      ToastService.defaultErrorToast()
    })
  }

  $scope.onToggleTrackReactions = (event) => {
    const { value } = event.detail

    $scope.trackReactionsChecked = value

    if ($scope.form.trackReactions === null) {
      $scope.form.trackReactions = $scope.form.trackReactionsCached

      return
    }

    if (!value) {
      $scope.form.trackReactions = null
    }
  }

  $scope.onChangeTrackReactions = (event) => {
    const { value } = event.detail

    $scope.form.trackReactionsCached = value
    $scope.form.trackReactions = value
  }

  $scope.handleAdvancedFeaturesClick = () => {
    if (!$scope.companyFeatures.advancedFeatures) {
      api._openUpgradeCompanyPlanDialog({
        featureName: $translate.instant('billingFeatures.postsAdvancedFeatures'),
        featureSlug: 'POSTS.ADVANCED_FEATURES'
      })
    }
  }

  function _validateCompanyFeatures (features) {
    $scope.companyFeatures.advancedFeatures = !!features['POSTS.ADVANCED_FEATURES']
    $scope.companyFeatures.groupSegmentation = !!features['POSTS.GROUPS_SEGMENTATION']
    $scope.selectedToggleOption = $rootScope.isUser() && $scope.companyFeatures.groupSegmentation ? 'GROUPS' : 'USERS'

    $scope.trackReactionsChecked = $scope.companyFeatures.advancedFeatures

    api._handleGroupSegmentation($scope.companyFeatures.groupSegmentation)
  }

  function _openUpgradeCompanyPlanDialog (modalData) {
    getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const openUpgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: modalData
      })

      openUpgradeCompanyPlanDialog.open()
    })
  }

  function _createVideoButton () {
    const trix = document.querySelector('.post-trix-editor')
    const videoButton = document.createElement('button')
    videoButton.setAttribute('type', 'button')
    videoButton.setAttribute('class', 'trix-button')
    videoButton.setAttribute('data-trix-attribute', 'video')
    videoButton.setAttribute('title', 'Embed Video')
    videoButton.setAttribute('tabindex', '-1')
    const videoIcon = document.createElement('i')
    videoIcon.classList.add('icon')
    videoIcon.classList.add('youtube')
    videoButton.appendChild(videoIcon)
    const placeholder = $translate.instant('youtubeUrl')
    const insert = $translate.instant('insert')
    const videoDialog = `
        <div class="trix-dialog trix-dialog--video" data-trix-dialog="video" data-trix-dialog-attribute="video">
          <div class="trix-dialog__link-fields">
            <input type="url" name="href" class="trix-input trix-input--dialog" placeholder="${placeholder}" aria-label="URL" required="" data-trix-input="" disabled="disabled">
            <div class="trix-button-group">
              <input type="button" class="trix-button trix-button--dialog" value="${insert}" data-trix-dialog-submit--video>
            </div>
          </div>
        </div>
      `
    const added = document.querySelector('.trix-dialog.trix-dialog--video')
    if (!added) {
      document.querySelector('.trix-button-group.trix-button-group--block-tools').appendChild(videoButton)
      document.querySelector('[data-trix-dialogs]').insertAdjacentHTML('beforeend', videoDialog)

      document.querySelector('[data-trix-dialog-submit--video]').addEventListener('click', function () {
        const videoElement = document.querySelector('[data-trix-dialog=video] input[name=href]')
        if (videoElement.value) {
          const videoId = api._getVideoId(videoElement.value)

          if (!videoId) {
            return
          }

          const videoEmbed = `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen></iframe>`
          const attachmentVideo = new Trix.Attachment({
            contentType: 'application/youtube-video.html',
            content: videoEmbed
          })
          const dialog = document.querySelector('.trix-dialog--video')
          const input = dialog.querySelector('.trix-input')

          input.value = ''
          trix.editor.insertAttachment(attachmentVideo)
          trix.editor.selectionManager.unlock()
        }
      })
    }
  }

  function _getVideoId (youTubeVideo) {
    const subs = youTubeVideo.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
    let videoId = null
    if (subs[2]) {
      videoId = subs[2].replace(/(&.*)/, '')
    }
    return videoId
  }

  function _handleSuccessGetUsers (res) {
    $scope.aUsers = res.rows.filter(function (oUser) {
      return oUser.id !== $rootScope.oUser.id
    })
    $scope.flags.bLoadingUsers = false
  }

  function _successGetCategories (oRes) {
    $scope.aPostCategories = oRes.rows
    $scope.aPostCategories.forEach(function (oCategory) {
      if (oCategory.parentCategory) {
        oCategory.name = oCategory.parentCategory.name + '  ->  ' + oCategory.name
      }
    })
    $scope.flags.bLoading = false
    jQuery('.newPostCategoryDropdown').dropdown({
      showOnFocus: false,
      clearable: true
    })
    $scope.flags.bLoading = false
  }

  $scope.handleAllUsersChange = function () {
    $scope.allUsersChecked = !$scope.allUsersChecked
  }

  $scope.refreshPost = function () {
    $scope.form = {
      attachments: [],
      thumbnail: [],
      groups: [],
      title: '',
      content: '',
      expirationDate: '',
      scheduleDate: '',
      notify: true,
      trackReactions: true
    }

    $scope.thumbnail = null
    $scope.files = []
    $scope.aGroups = []
    $scope.today = moment()

    $scope.flags = {
      bLoading: true,
      bLoadingViewers: false,
      showAdvancedOptions: false
    }

    $scope.activate()
  }

  function _handleGetGroupsResponse (oRes) {
    _iGroupsCount = oRes.d.__count
    $scope.aGroups = $scope.aGroups.concat(oRes.d.results)
    // Since dropdown doesn't support pagination we need to load all pages at
    if ($scope.aGroups.length < _iGroupsCount) {
      _iCurrentSkipGroups += 1
      GroupService.getGroups(_iCurrentTop, _iCurrentTop * _iCurrentSkipGroups, null, true).then(api._handleGetGroupsResponse)
    } else {
      $scope.flags.bLoading = false
      jQuery('.posts-groups-dropdown').dropdown({
        showOnFocus: false,
        onChange: function () {
          if (!$scope.$$phase) {
            $scope.$apply()
          }
        }
      })
    }
  }

  function _getUsers () {
    if ($rootScope.isUser()) {
      return Promise.resolve()
    }

    $scope.flags.bLoadingUsers = true
    return AdminService.getUsersSimplified({ active: true }).then(api._handleSuccessGetUsers)
  }

  function _getGroups () {
    if ($rootScope.isUser() && !$rootScope.oUser.canCreatePost) {
      return Promise.resolve()
    }

    $scope.flags.bLoading = true
    return GroupService.getGroups(_iCurrentTop, _iCurrentSkipGroups, null, true).then(api._handleGetGroupsResponse)
  }

  function _getPostsCategories () {
    return PostsService.getPostCategories().then(api._successGetCategories).catch(ToastService.defaultErrorToast)
  }

  $scope.$on('$destroy', () => {
    deregisterDownloadedAssetPreviewHeader()
  })

  $scope.openPreview = (index) => {
    const asset = $scope.files[index]

    AssetPreviewService.openAssetPreview({
      asset: asset,
      getPreviewAssets: api._getPreviewAssets,
      location,
      postId: $scope._postId
    })

    PostsService.registerAttachmentLog(asset.id, $scope._postId, 'VIEW')
  }

  function _getPreviewAssets () {
    const deferred = $q.defer()
    $timeout(() => {
      deferred.resolve({
        assets: $scope.files,
        count: $scope.files.length
      })
    }, 100, true)
    return deferred.promise
  }

  $scope.openAttachAssetsDialog = function () {
    getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
      const attachInsideTheModuleModal = UdsModalService.createModal({
        controller: AttachInsideTheModuleModalController,
        modalName: 'attachInsideTheModuleModal',
        data: {
          selectedTab: 'recents'
        },
        onClose: (assetsToAttach) => {
          if (!assetsToAttach?.length) {
            return
          }

          $scope.flags.bLoading = true
          const promises = assetsToAttach.map(asset => NewAssetService.getAssetDetails(asset.id))

          Promise.all(promises).then((assets) => {
            for (const asset of assets) {
              $timeout(() => {
                $scope.uploadedFiles.push(asset)
                $scope.form.attachments.push(asset)
                $scope.files.push(asset)
                $scope.flags.bLoading = false
              })
            }
          })
        }
      })

      attachInsideTheModuleModal.open()
    })
  }

  $scope.attach = function (aFiles) {
    $scope.flags.bLoading = true

    return UploadService.uploadMultipleFileToS3(aFiles).then((uploadedFiles) => {
      const assets = uploadedFiles

      $timeout(() => {
        assets.forEach((asset) => {
          const uploadedFile = asset.files[0]
          const attachment = {
            ...uploadedFile,
            ...asset,
            generatingThumb: true
          }

          $scope.uploadedFiles.push(attachment)
          $scope.form.attachments.push(attachment)
          $scope.files.push(attachment)
        })
      })
    }).catch(error => {
      if (BackendErrorParserService.isInvalidFileError(error)) {
        ToastService.showErrorToast($translate.instant('fileExtensionNotAllowed'))
      }
    }).finally(() => {
      $timeout(() => {
        $scope.flags.bLoading = false
      })
    })
  }

  $scope.attachThumbnail = function (aFiles) {
    $scope.thumbnail = null
    $scope.flags.bLoading = true
    $scope.form.thumbnail = null

    return UploadService.uploadMultipleFileToS3(aFiles)
      .then((uploadedFiles) => {
        const assets = uploadedFiles

        $timeout(() => {
          assets.forEach((asset) => {
            const uploadedFile = asset.files[0]
            const attachment = {
              ...uploadedFile,
              ...asset,
              thumbnailSrc: NewAssetService.getAssetThumbnailUrl(asset.id, 'LOW'),
              generatingThumb: true
            }

            setInterval(() => {
              if (!$scope.thumbnail) {
                return
              }

              $timeout(() => {
                $scope.thumbnail.thumbnailSrc = NewAssetService.getAssetThumbnailUrl(asset.id, 'LOW', { includeDateAsQueryString: true })
                $scope.showThumbnail = true
              })
            }, 5000)

            $scope.uploadedFiles.push(attachment)
            $scope.form.thumbnail = attachment
            $scope.thumbnail = attachment
          })
        })
      }).catch(error => {
        if (BackendErrorParserService.isInvalidFileError(error)) {
          ToastService.showErrorToast($translate.instant('fileExtensionNotAllowed'))
        }
      }).finally(() => {
        $timeout(() => {
          $scope.flags.bLoading = false
        })
      })
  }

  $scope.disattach = function (oRemoveAttachment) {
    const removeAssetFromArray = () => {
      const fileIndex = $scope.files.findIndex(file => file.id === oRemoveAttachment)
      const attachmentIndex = $scope.form.attachments.findIndex(elem => {
        if (typeof elem === 'object') {
          return elem.id === oRemoveAttachment
        }

        return elem === oRemoveAttachment
      })

      if (attachmentIndex !== -1) {
        $scope.form.attachments.splice(attachmentIndex, 1)
      }

      if (fileIndex !== -1) {
        $scope.files.splice(fileIndex, 1)
      }

      $scope.flags.bLoading = false
    }

    $scope.flags.bLoading = true

    if (!$scope._postId) {
      return removeAssetFromArray()
    }

    PostsService.removeAssetFromPost($scope._postId, oRemoveAttachment)
      .then(removeAssetFromArray).catch(removeAssetFromArray)
  }

  $scope.getCampaignInfoBannerText = () => {
    return $translate.instant('campaignInfoBanner.post', { campaignName: $scope.post?.campaignName })
  }

  function _successAttachThumbnail () {
    $scope.flags.bLoading = false
    $scope.thumbnail = api._setThumbnail($scope.thumbnail.id, false)
    $scope.showThumbnail = true
  }

  function _getGroupValues () {
    if ($scope.selectedToggleOption === 'GROUPS') {
      var aGroups = element.find('.posts-groups-dropdown').dropdown('get values') || []

      return aGroups.map(function (sGroupId) {
        return parseInt(sGroupId)
      })
    }
  }

  function _getUserValues () {
    if ($scope.selectedToggleOption === 'USERS') {
      return $scope.form.targetUsers.map(function (oUser) {
        return oUser.id
      })
    }
  }

  function _removeDateCacheFromEmbeddedImages (content) {
    const doc = new DOMParser().parseFromString(content, 'text/html')
    const imgs = doc.querySelectorAll('img')

    if (!imgs.length) {
      return content
    }

    imgs.forEach((img) => {
      const url = new URL(img.src)
      url.searchParams.delete('date')
      img.src = url.toString()
    })

    return doc.activeElement.innerHTML
  }

  function _submitPost (deferred) {
    $scope.flags.bLoading = true
    $scope.form.attachments = _putOnlyEmbeddedAttachmentsInContent($scope.form.attachments, $scope.form.content)
    $scope.form.content = _removeDateCacheFromEmbeddedImages($scope.form.content)

    const groups = $scope.allUsersChecked ? [] : api._getGroupValues()
    const targetUsers = $scope.allUsersChecked ? [] : api._getUserValues()

    const scheduledDate = $scope.form.scheduleDate
    if (typeof scheduledDate === 'object' && scheduledDate !== null) {
      scheduledDate.minute(0)
      scheduledDate.second(0)
    }

    var postData = {
      title: $scope.form.title,
      content: $scope.form.content,
      groups,
      targetUsers,
      category: $scope.form.category ? $scope.form.category : undefined,
      expirationDate: typeof $scope.form.expirationDate === 'object' && $scope.form.expirationDate !== null ? $scope.form.expirationDate.toISOString() : undefined,
      scheduleDate: typeof scheduledDate === 'object' && scheduledDate !== null ? scheduledDate.toISOString() : undefined,
      thumbnail: $scope.form.thumbnail || $scope.thumbnail,
      notify: $scope.form.notify,
      trackReactions: $scope.form.trackReactions,
      campaignId: $scope.form.campaignId,
      autoShowAfterLogin: $scope.form.autoShowAfterLogin
    }
    const attachments = $scope.form.attachments.filter((attachment) => !attachment.isEmbedded)

    if ($scope._existingPost) {
      PostsService.editPost($scope._postId, postData)
        .then(function () {
          PostsService.attachAssetsToPost($scope._postId, attachments).then(() => {
            api._handleSuccess()
            deferred.resolve()
          })
        })
        .catch(function (error) {
          $scope.flags.bLoading = false
          if (error.data.code === 'POST_WITH_PUBLISHED_CAMPAIGN_ACTION') {
            ToastService.showErrorToast($translate.instant('campaignErrors.postWithPublishedCampaignAction'))
          } else if (error.data.reason.includes('expiration')) {
            ToastService.showErrorToast($translate.instant('campaignErrors.postExpirationBeforeCampaign'))
          } else {
            ToastService.defaultErrorToast()
          }
          deferred.reject()
        })
    } else {
      PostsService.createPost(postData)
        .then(function (post) {
          SegmentService.track('created-announcement', {
            post_id: post.id,
            number_of_attachments: $scope.form.attachments.length,
            has_category: Boolean(postData.category),
            has_scheduler: Boolean(postData.scheduleDate),
            has_notification: postData.notify,
            has_restriction: Boolean(postData.groups?.length || postData.targetUsers?.length),
            rating_enable: !!postData.trackReactions,
            rating_type: postData.trackReactions,
            campaign_id: postData.campaignId
          })

          PostsService.attachAssetsToPost(post.id, attachments).then(() => {
            api._handleSuccess()
            deferred.resolve()
          })
        })
        .catch(function (error) {
          if (error.status === 422 && error.data.reason.includes('expired')) {
            ToastService.showErrorToast($translate.instant('campaignErrors.expiredCampaign'))
          } else {
            ToastService.defaultErrorToast()
          }
          $scope.flags.bLoading = false
          deferred.reject()
        })
    }
  }

  function _putOnlyEmbeddedAttachmentsInContent (attachments, content) {
    return attachments.map(attachment => {
      if (attachment && attachment.isEmbedded && content.includes(attachment.id)) {
        return null
      } else if (attachment && !attachment.isEmbedded) {
        return attachment.id ? attachment.id : attachment
      }
    }).filter(attachment => (typeof attachment !== 'undefined') && (attachment !== null))
  }

  function _handleSuccess () {
    $scope.flags.bLoading = false
    ToastService.defaultSuccessToast()
    ModalService.close(true)
  }

  $scope.handleCancelButtonClick = function () {
    ModalService.close()
    $rootScope.$emit('campaign.actions.complete-action')
  }

  $scope.handleSendButtonClick = function () {
    if ($scope.flags.bLoading) {
      return
    }

    if (!$scope.form.trackReactions && $scope.trackReactionsChecked) {
      $scope.form.trackReactions = defaultTrackReaction
      $scope.form.trackReactionsCached = defaultTrackReaction
    }

    if (!$scope.selectedCampaign || ($scope.post?.campaignId !== $scope.selectedCampaign?.id)) {
      $scope.form.campaignId = $scope.selectedCampaign?.id || null
      SegmentService.track('created-announcement', {
        campaign_id: $scope.selectedCampaign?.id,
        automatic_open: $scope.form.autoShowAfterLogin
      })
    }

    let deferred = $q.defer()
    if ($rootScope.isUser() && api._getGroupValues().length === 0) {
      deferred = undefined
      return
    }

    api._submitPost(deferred)
    return deferred.promise
  }

  $scope.handleRichTextEditorInit = function (e, editor) {
    $scope._richTextEditor = editor
    TrixEditorService.trixAutoLinker(e.target)
  }

  $scope.handleRichTextFieldFocus = function (e, editor) {
    jQuery($scope._richTextEditor.composition.delegate.toolbarController.element).addClass('show')
  }

  $scope.handleRichTextFieldBlur = function (e, editor) {
    if (jQuery(document.activeElement).hasClass('trix-input')) {
      return
    }
    jQuery($scope._richTextEditor.composition.delegate.toolbarController.element).removeClass('show')
  }

  $scope.sendBtnIsDisabled = function () {
    return !$scope.flags.bLoading && ($scope.form.title === '' || $scope.form.content === '' || ($rootScope.isUser() && api._getGroupValues()?.length === 0) || (!$scope.allUsersChecked && ($scope.form?.targetUsers?.length <= 0 && api._getGroupValues()?.length <= 0)))
  }

  function _setAttachments (aFiles) {
    if (!aFiles) {
      return
    }

    aFiles = aFiles.map(function (oFile) {
      return angular.extend(oFile, {
        src: {
          original: Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [oFile.id]),
          default: AssetService.getAssetThumbnailByType(oFile.type),
          thumbnail: Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_THUMBNAIL_ID, [oFile.id])
        },
        contentType: oFile.contentType,
        type: oFile.type
      })
    }, this)
  }

  function _setThumbnail (iThumbnail, existingThumbnail) {
    if (iThumbnail) {
      if (existingThumbnail) {
        return {
          id: iThumbnail,
          thumbnailSrc: NewAssetService.getAssetThumbnailUrl(iThumbnail, 'LOW')
        }
      } else {
        return {
          id: iThumbnail,
          thumbnailSrc: NewAssetService.getAssetThumbnailUrl(iThumbnail, 'LOW')
        }
      }
    } else {
      return iThumbnail
    }
  }

  $scope.downloadAttachment = function (attachment) {
    $scope.flags.bLoadingDownload = true
    PostsService.downloadAttachment(attachment.id).then(() => {
      $scope.flags.bLoadingDownload = false
      SegmentService.track('downloaded-attachment', { attachment_id: attachment.id, post_id: $scope._postId })
      PostsService.registerAttachmentLog(attachment.id, $scope._postId, 'DOWNLOAD')
    })
  }

  const deregisterDownloadedAssetPreviewHeader = $scope.$on('downloadedAssetPreviewHeader', (e, assetId) => {
    SegmentService.track('downloaded-attachment', { attachment_id: assetId, post_id: $scope._postId })
    PostsService.registerAttachmentLog(assetId, $scope._postId, 'DOWNLOAD')
  })

  $scope.downloadWithProgress = function (sId, progressCallback, callback) {
    AttachmentService.downloadWithProgress(sId, progressCallback, callback, CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, {
      query: {
        jwt: $cookies.get('jwt')
      },
      externalUrl: true
    }).then(PostsService.registerAttachmentLog.bind(this, sId, $scope._postId, 'DOWNLOAD'))
      .then(() => {
        SegmentService.track('downloaded-attachment', { attachment_id: sId, post_id: $scope._postId })
      })
  }

  $scope.attActions = {
    download: $scope.downloadAttachment,
    downloadWithProgress: $scope.downloadWithProgress,
    delete: $scope.disattach.bind($scope),
    logPostView,
    seeAttachmentLogs
  }

  $scope.createGroup = function () {
    api.getNewGroupDialogController().then(({ NewGroupDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: NewGroupDialogController,
        modalName: 'newGroupDialog',
        onClose: (bEmailSuccessfullySent) => {
          if (bEmailSuccessfullySent) {
            api._getGroups()
            ToastService.defaultSuccessToast()
          }
        }
      })
      modal.open()
    })
  }

  $scope.createPostCategories = function (artCategory) {
    api.getCreatePostCategoryDialogController().then(({ CreatePostCategoryDialogController }) => {
      const oldModalReference = ModalService.getCurrentModal()
      ModalService.showModal({
        templateId: 'createPostCategory.html',
        templateUrl: '/admin/dialogs/create-post-category/create-post-category-dialog.html?$$REVISION$$',
        destroyable: true,
        allowMultiple: true,
        observeChanges: true,
        data: {
          oPostCategory: {}
        },
        controller: CreatePostCategoryDialogController
      })
        .then(function (bReloadList) {
          if (bReloadList) {
            api._getPostsCategories()
            ToastService.defaultSuccessToast()
          }
          if (oldModalReference) {
            ModalService.setCurrentModal(oldModalReference)
          }
        })
    })
  }

  function seeAttachmentLogs (attachmentId) {
    if ($rootScope.isDesktop) {
      const el = element.find('.asset-logs')

      if ($scope.flags.seeAttachmentLogs) {
        hideComments(el)
        $scope.flags.seeAttachmentLogs = false
      } else {
        showComments(el)
        $scope.attachmentStatistics = {
          id: attachmentId
        }
        $scope.flags.seeAttachmentLogs = true
        $scope.getLogs()
      }
    } else {
      SliderService.setState('post-slider', 'close')
      SliderService.setState('attachment-logs-slider', 'open', {
        attachmentId,
        postId: $scope._postId
      })
    }
  }

  function logPostView (attachmentId) {
    PostsService.registerAttachmentLog(attachmentId, $scope._postId, 'VIEW')
    SegmentService.track('previewed-attachment', { attachment_id: attachmentId, post_id: $scope._postId })
  }

  // Setting thumbnail and attachments and formatting content to html - Remembering *Thumbnails are treated as attachments*
  function _getPostById (postId, bExistingPost) {
    PostsService.getPostById(postId).then(post => {
      const getCompanyLogo = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANY_LOGO, [post.customerCompanyId])
      const getCompanyColor = CustomerConfigurationsService.getOneConfigurationByType('COMPANY_PRIMARY_COLOR', 'STRING', post.customerCompanyId)

      $scope.autoShowAfterLogin = post.autoShowAfterLogin

      if ($scope._storedPosts && $scope.currentPostIndex >= 0) {
        $scope.postVisualized = $scope._storedPosts[$scope.currentPostIndex].visualized || false
      } else {
        $scope.postVisualized = false
      }

      return $q.all([getCompanyLogo, getCompanyColor]).then(result => {
        return {
          post: post,
          logo: result[0],
          color: result[1]
        }
      })
    }).then(function (result) {
      const oPost = result.post
      const companyColor = result.color && result.color.value
      $scope.isCampaignSelected = !!oPost.campaignId && oPost.isActiveInCampaign !== false

      if (!oPost.autoShowAfterLogin) {
        SegmentService.track('read-announcement', { post_id: oPost.id, automatic_open: oPost.autoShowAfterLogin })
      }

      $scope.customerLogo = result.logo
      $scope.customerColor = companyColor || $rootScope.customerColor

      $scope.files = angular.copy(oPost.attachments.filter(attachment => attachment.type !== 'EMBEDDED').map((attachment) => {
        const originalFile = attachment.files.find(file => file.quality === 'ORIGINAL')

        return {
          ...originalFile,
          ...attachment
        }
      }))
      $scope.thumbnail = null
      $scope.thumbnail = oPost.thumbnailId
      $scope.thumbnail = api._setThumbnail($scope.thumbnail, true)
      api._setAttachments($scope.files)

      if (oPost.campaignId) {
        $scope.currentCampaignId = oPost.campaignId
      }

      if (bExistingPost) {
        $scope.form = angular.extend($scope.form, oPost)
        $scope.form.attachments = $scope.form.attachments.map(function (attachment) {
          return {
            id: attachment.id,
            isEmbedded: attachment.type === 'EMBEDDED'
          }
        })

        if (oPost.targetUsers.length > 0 || oPost.groups.length > 0) {
          $scope.allUsersChecked = false
        }

        if (oPost.expirationDate) {
          $scope.form.expirationDate = moment(oPost.expirationDate)
          $scope.flags.showAdvancedOptions = true
        }

        if (oPost.scheduleDate) {
          $scope.form.scheduleDate = moment(oPost.scheduleDate)
          $scope.flags.showAdvancedOptions = true
        }

        $scope.form.groups = $scope.form.groups.map(function (group) {
          return group.id.toString()
        })

        if (oPost.category) {
          $scope.form.category = oPost.category.id
        }

        if ($scope.form.targetUsers.length) {
          $scope.selectedToggleOption = 'USERS'
        } else if ($scope.form.groups.length) {
          $scope.selectedToggleOption = 'GROUPS'
        }

        api._addDropdownValue($scope.form.groups)
      } else {
        $scope.post = oPost
        const replaceString = oPost.content.replace('<a href', '<a target="_blank" href')
        const noCachePostContent = _removeDateCacheFromEmbeddedImages(replaceString)
        $scope.post.content = $sce.trustAsHtml(noCachePostContent)
      }

      if ($scope._openResults) {
        api._handleSeeReaders()
      }

      $scope.flags.bLoading = false

      if ($scope._openedByNotification && $scope.post.campaignId) {
        SegmentService.track('read-announcement', { campaign_id: $scope.post.campaignId })
      }
    })
  }

  $scope.copyPostLink = function (post) {
    PostsService.copyPostUrlToClipboard(post.id)
      .then(() => {
        ToastService.showSuccessToast($translate.instant('copyPostLink.toast.success'))
      })
      .catch(() => {
        ToastService.showErrorToast($translate.instant('copyPostLink.toast.error'))
      })
  }

  $scope.handleClickOnEdit = function () {
    const postViewers = element.find('.post-views')
    const attachmentLogsView = element.find('.asset-logs')

    if ($scope.flags.seeReaders) {
      hideComments(postViewers)
    }

    if ($scope.flags.seeAttachmentLogs) {
      hideComments(attachmentLogsView)
    }

    $scope._editMode = true
    $scope._existingPost = true
    $scope.flags.bLoading = true
    $scope.flags.seeReaders = false
    $scope.flags.seeAttachmentLogs = false
    api._getPostsCategories()
    api._getPostById($scope._postId, true)
    $scope.activate()

    if ($scope.post.campaignId) {
      SegmentService.track('announcement-update', { campaign_id: $scope.post.campaignId })
    }

    $scope.form.trackReactions = $scope.post.trackReactions
    $scope.form.trackReactionsCached = $scope.post.trackReactions

    if (!$scope.post.trackReactions) {
      $scope.trackReactionsChecked = false
    } else {
      $scope.disabledSelectReactions = true
    }

    $timeout(() => {
      $scope.reactions.metrics = $scope.reactions.metrics.map(reactionMetric => {
        if (reactionMetric.value === $scope.post.trackReactions) {
          return {
            ...reactionMetric,
            active: true
          }
        }

        return {
          ...reactionMetric,
          active: false
        }
      })
    }, 0, true)
  }

  $scope.handleCampaignChange = (campaign) => {
    $scope.form.targetUsers = []
    $scope.form.groups = []
    $scope.form.expirationDate = null
    $scope.form.scheduleDate = null

    $('.posts-groups-dropdown').dropdown('clear')
    api._fillInputsWithCampaignInfo(campaign)
    $scope.isCampaignSelected = !!campaign
  }

  $scope.getCurrentCampaignId = () => {
    return $scope.post?.isActiveInCampaign === false ? null : $scope.currentCampaignId
  }

  function hideComments (el) {
    el.fadeTo(500, 0)
    $timeout(() => {
      el.css('display', 'none')
    }, 500, false)
  }

  function showComments (el) {
    el.fadeTo(500, 1)
  }

  function _addDropdownValue (groups) {
    $timeout(function () {
      jQuery('.posts-groups-dropdown')
        .dropdown('set selected', groups)
    }, 150, false)
  }

  $scope.handleSeeReaders = api._handleSeeReaders

  $scope.handleArchivePostClick = function () {
    MessageService.error({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureArchivePost'),
      confirmButton: $translate.instant('yesImSure'),
      cancelButton: $translate.instant('cancel'),
      press: function () {
        PostsService.archivePost($scope._postId, { isArchived: true }).then(
          api._handleSuccess
        ).catch(function (params) {
          ToastService.defaultErrorToast()
        })
      },
      closeOnConfirm: true
    })
  }

  $scope.handleUnarchivePostClick = function () {
    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureUnarchivePost'),
      confirmButton: $translate.instant('yesImSure'),
      cancelButton: $translate.instant('cancel'),
      press: function () {
        PostsService.archivePost($scope._postId, { isArchived: false }).then(
          api._handleSuccess
        ).catch(function () {
          ToastService.defaultErrorToast()
        })
      },
      closeOnConfirm: true
    })
  }

  $scope.toggleAdvancedOptionsVisibility = function () {
    $scope.flags.showAdvancedOptions = !$scope.flags.showAdvancedOptions
  }

  $scope.getCustomerLogo = function () {
    return $scope.customerLogo || $rootScope.getCustomerLogo()
  }

  $scope.activate()

  function _getDefaultReaction (metrics) {
    return metrics.reduce((acc, metric) => {
      if (!acc && metric.active) {
        acc = metric.value
      }

      return acc
    }, '')
  }

  function _handleSeeReaders () {
    if ($rootScope.isDesktop) {
      const postViewsEl = element.find('.post-views')
      const assetLogsEl = element.find('.asset-logs')

      $scope.flags.bLoadingViewers = true

      if ($scope.flags.seeReaders) {
        hideComments(postViewsEl)
        $scope.flags.seeReaders = false
      } else {
        hideComments(assetLogsEl)
        $scope.flags.seeAttachmentLogs = false
        $scope.getPostReaders($scope._postId)
        showComments(postViewsEl)
        $scope.flags.seeReaders = true
      }

      $timeout(function () {
        $scope.flags.bLoadingViewers = false
      }, 300)
    } else {
      SliderService.setState('post-slider', 'close')
      SliderService.setState('readers-slider', 'open', {
        post: $scope.post
      })
    }
  }

  function _fillInputsWithCampaignInfo (campaign) {
    if (!campaign) return

    $scope.form.scheduleDate = moment(campaign.info.startDate)
    $scope.form.expirationDate = moment(campaign.info.deliveryDate)
    $scope.dateRange.minDate = moment(campaign.info.startDate)
    $scope.dateRange.maxDate = moment(campaign.info.deliveryDate)

    if (campaign.info.groups?.length) {
      $scope.allUsersChecked = false
      $scope.selectedToggleOption = 'GROUPS'
      $scope.form.groups = campaign.info.groups.map(group => group.id.toString())
      api._addDropdownValue($scope.form.groups)
    } else {
      $scope.allUsersChecked = true
      $scope.selectedToggleOption = 'USERS'
    }
  }

  function _getSelectedCampaign () {
    if (!$scope.currentCampaignId) return

    CampaignService.getCampaign($scope.currentCampaignId).then(campaign => {
      api._fillInputsWithCampaignInfo({ info: campaign })
    })
  }
}

export { PostCoreController }
